import React from 'react';
import {
	Document,
	Font,
	Page,
	Text,
	StyleSheet,
	View,
	Image,
} from '@react-pdf/renderer';
import EmptySpace from './Components/EmptySpace'
import {List, ListItem} from './Components/BulletPiontList'
import logo from '../../images/iek_logo.png'
import oneRoadTable from '../../images/light/count/oneRodTable.png'
import twoRoadTable from '../../images/light/count/twoRodTable.png'
import oneCableTable from '../../images/light/count/oneCableTable.png'
import twoCableTable from '../../images/light/count/twoCableTable.png'
import table from '../../images/light/count/table.png'
import osm from '../../images/light/count/osm.jpg'
import otm from '../../images/light/count/otm.jpg'
import dsm from '../../images/light/count/dsm.jpg'
import dtm from '../../images/light/count/dtm.jpg'


Font.register({
	family: "Roboto",
	fonts: [
		{ src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-light-webfont.ttf", fontWeight: 300 },
		{ src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-regular-webfont.ttf", fontWeight: 400 },
		{ src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-medium-webfont.ttf", fontWeight: 500 },
		{ src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-bold-webfont.ttf", fontWeight: 600 },
	]
});


const styles = StyleSheet.create({
	body: {
		paddingTop: 35,
		paddingBottom: 65,
		paddingHorizontal: 35,
	},
	logo: {
		position: 'absolute',
		top: 0,
		left: 0,
		marginLeft: 12,
		height:30,
		textAlign: 'center',
	},
	colon:{
		marginTop: 6,
		textAlign: 'center',
		fontSize: 12,
		color: 'grey',
		fontFamily: 'Roboto',
		paddingHorizontal: '20%'
	},
	tor:{
		position: 'absolute',
		top: 6,
		right: 12,
		fontSize: 12,
		color: 'grey',
		fontFamily: 'Roboto',
	},
	pageNumber: {
		position: 'absolute',
		bottom: 18,
		right: 48,
		fontSize: 12,
		color: 'grey',
	},

	description: {
		fontSize: 12,
		fontFamily: 'Roboto',
		marginLeft: 12,
	},
	title:{
		fontSize: 16,
		textAlign: 'center',
		fontFamily: 'Roboto',
	},
	subtitle: {
		fontSize: 16,
		textAlign: 'center',
		fontFamily: 'Roboto',
		fontWeight:'bold'
	},
	fw_bold: {
		fontWeight:'bold'
	},
	fw_normal:{
		fontWeight:'normal'
	},
	text:{
		marginHorizontal: 12,
		fontSize: 12,
		textAlign: 'justify',
		fontFamily: 'Roboto',
	},
	formula:{
		textAlign: 'center',
		fontFamily: 'Roboto',
		marginVertical:6
	},
	formula_header:{
		fontSize: 12,
		fontWeight:'normal'
	},
	formula_content:{
		fontSize: 12,
		fontWeight:'bold'
	},
	tableContainer: {
		flexDirection: "row",
		flexWrap: "wrap",
		fontSize:12,
		fontFamily: 'Roboto',
	},
	row: {
		flexDirection: "row",
	},
	big:{
		height:50,
	},
	small:{
		height:30,
	},
	first_table_sell:{
		textAlign: 'center',
		borderLeft:'1px solid #000',
		paddingHorizontal:5,
		paddingTop: 8
	},
	fs_small:{
		fontSize:10,
	},
	image: {
		marginLeft: 12,
		height:350,
		textAlign: 'center',
		objectFit:'contain'
	},
	m12:{
		margin: 12,
	}

})


const ONE_ROD = 'one_rod'
const TWO_ROD = 'two_rod'
const ONE_CABLE = 'one_cable'
const TWO_CABLE = 'two_cable'

const RELIAB_MIN 	= 0.9
const RELIAB_AVER = 0.99
const RELIAB_MAX 	= 0.999

const FData = (props) => {
	const { reliability, buildHeight, light, zoneHeight, radiusGround,
		radiusTop, lmax, sagHeight, distanceSec, viewSec, buildLength, buildWidth, type, td, n, hx, l, rcx, hc} = props.props
	switch (viewSec){
		case ONE_ROD:
			return (<View>
				<Text style={{...styles.description, marginLeft:24, marginBottom:1, fontSize: 16,}}>Исходные данные:</Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Тип здания: <span style={{fontWeight:'bold'}}>{type}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Среднегодовая продолжительность гроз, Td, ч: <span style={{fontWeight:'bold'}}>{td}</span></Text>
				{type === 'Прямоуголный'
					?
					<View>
						<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Длина здания, l, м: <span style={{fontWeight:'bold'}}>{buildLength}</span></Text>
						<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Ширина здания, b, м: <span style={{fontWeight:'bold'}}>{buildWidth}</span></Text>
					</View>
					: null
				}
			  <Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Высота здания, Hmax, м: <span style={{fontWeight:'bold'}}>{buildHeight}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Надежность защиты от ПУМ: <span style={{fontWeight:'bold'}}>{reliability}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Высота молниеотвода, h, м: <span style={{fontWeight:'bold'}}>{light}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Высота, hx, м: <span style={{fontWeight:'bold'}}>{hx}</span></Text>
				<EmptySpace />
				<Text style={{...styles.description, marginLeft:24, marginBottom:1, fontSize: 16,}}>Результат:</Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Высота зоны, h0, м: <span style={{fontWeight:'bold'}}>{zoneHeight}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Радиус зоны на уровне земли, r0, м: <span style={{fontWeight:'bold'}}>{radiusGround}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Радиус зоны на уровне высоты здания, rx, м: <span style={{fontWeight:'bold'}}>{radiusTop}</span></Text>
				<EmptySpace />

			</View>)
		case TWO_ROD:
			return (<View>
				<Text style={{...styles.description, marginLeft:24, marginBottom:1, fontSize: 16,}}>Исходные данные:</Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Тип здания: <span style={{fontWeight:'bold'}}>{type}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Среднегодовая продолжительность гроз, Td, ч: <span style={{fontWeight:'bold'}}>{td}</span></Text>
				{type === 'Прямоуголный'
					?
					<View>
						<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Длина здания, l, м: <span style={{fontWeight:'bold'}}>{buildLength}</span></Text>
						<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Ширина здания, b, м: <span style={{fontWeight:'bold'}}>{buildWidth}</span></Text>
					</View>
					: null
				}
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Высота здания, Hmax, м: <span style={{fontWeight:'bold'}}>{buildHeight}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Надежность защиты от ПУМ: <span style={{fontWeight:'bold'}}>{reliability}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Высота молниеотвода, h, м: <span style={{fontWeight:'bold'}}>{light}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Высота, hx, м: <span style={{fontWeight:'bold'}}>{hx}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Расстояние между стержневыми молниеприемниками, L, м: <span style={{fontWeight:'bold'}}>{l}</span></Text>
				<EmptySpace />
				<Text style={{...styles.description, marginLeft:24, marginBottom:1, fontSize: 16,}}>Результат:</Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Предельное расстояние между стержневыми молниеприемниками, Lmax, м: <span style={{fontWeight:'bold'}}>{lmax}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Высота зоны, h0, м: <span style={{fontWeight:'bold'}}>{zoneHeight}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Радиус зоны на уровне земли, r0, м: <span style={{fontWeight:'bold'}}>{radiusGround}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Радиус зоны на уровне высоты здания, rx, м: <span style={{fontWeight:'bold'}}>{radiusTop}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Высота провеса, hc, м: <span style={{fontWeight:'bold'}}>{hc}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Полуширина горизонтального сечения, rcx, м: <span style={{fontWeight:'bold'}}>{rcx}</span></Text>
				<EmptySpace />

			</View>)
		case ONE_CABLE:
			return (<View>
				<Text style={{...styles.description, marginLeft:24, marginBottom:1, fontSize: 16,}}>Исходные данные:</Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Тип здания: <span style={{fontWeight:'bold'}}>{type}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Среднегодовая продолжительность гроз, Td, ч: <span style={{fontWeight:'bold'}}>{td}</span></Text>
				{type === 'Прямоуголный'
					?
					<View>
						<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Длина здания, l, м: <span style={{fontWeight:'bold'}}>{buildLength}</span></Text>
						<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Ширина здания, b, м: <span style={{fontWeight:'bold'}}>{buildWidth}</span></Text>
					</View>
					: null
				}
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Высота здания, Hmax, м: <span style={{fontWeight:'bold'}}>{buildHeight}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Надежность защиты от ПУМ: <span style={{fontWeight:'bold'}}>{reliability}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Высота молниеотвода, h, м: <span style={{fontWeight:'bold'}}>{light}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Высота, hx,м: <span style={{fontWeight:'bold'}}>{hx}</span></Text>
				<EmptySpace />
				<Text style={{...styles.description, marginLeft:24, marginBottom:1, fontSize: 16,}}>Результат:</Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Высота зоны, h, м: <span style={{fontWeight:'bold'}}>{zoneHeight}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Радиус зоны на уровне земли, r0, м: <span style={{fontWeight:'bold'}}>{radiusGround}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Радиус зоны на уровне высоты здания, rx, м: <span style={{fontWeight:'bold'}}>{radiusTop}</span></Text>
				<EmptySpace />
			</View>)
		case TWO_CABLE:
			return (<View>
				<Text style={{...styles.description, marginLeft:24, marginBottom:1, fontSize: 16,}}>Исходные данные:</Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Тип здания: <span style={{fontWeight:'bold'}}>{type}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Среднегодовая продолжительность гроз, Td, ч: <span style={{fontWeight:'bold'}}>{td}</span></Text>
				{type === 'Прямоуголный'
					?
					<View>
						<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Длина здания, l, м: <span style={{fontWeight:'bold'}}>{buildLength}</span></Text>
						<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Ширина здания, b, м: <span style={{fontWeight:'bold'}}>{buildWidth}</span></Text>
					</View>
					: null
				}
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Высота здания, Hmax, м: <span style={{fontWeight:'bold'}}>{buildHeight}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Надежность защиты от ПУМ: <span style={{fontWeight:'bold'}}>{reliability}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Высота молниеотвода, h, м: <span style={{fontWeight:'bold'}}>{light}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Высота, hx,м: <span style={{fontWeight:'bold'}}>{hx}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Расстояние до второго молниеотвода, S, м: <span style={{fontWeight:'bold'}}>{distanceSec}</span></Text>
				<EmptySpace />
				<Text style={{...styles.description, marginLeft:24, marginBottom:1, fontSize: 16,}}>Результат:</Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Предельное расстояние между стержневыми молниеприемниками, Lmax, м: <span style={{fontWeight:'bold'}}>{lmax}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Высота зоны, h0, м: <span style={{fontWeight:'bold'}}>{zoneHeight}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Высота провеса, hc, м: <span style={{fontWeight:'bold'}}>{sagHeight}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Радиус зоны на уровне земли, r0, м: <span style={{fontWeight:'bold'}}>{radiusGround}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Радиус зоны на уровне высоты здания, rx, м: <span style={{fontWeight:'bold'}}>{radiusTop}</span></Text>
				<Text style={{...styles.text, marginLeft:24, marginBottom:1, marginTop:1}}>Полуширина горизонтального сечения, rcx, м: <span style={{fontWeight:'bold'}}>{rcx}</span></Text>
				<EmptySpace />
			</View>)
	}

	return (<View/>)
}

const FContent = (props) => {
	const { reliability, buildHeight, light, zoneHeight, radiusGround,
		radiusTop, lmax, sagHeight, distanceSec, viewSec, Lc, hx, rcx, l, hc} = props.props
		switch (viewSec){
			case ONE_ROD:
				return (<View>
					<Text  style={styles.description}>Расчет зоны молниезащиты одиночного стержневого молниеотвода</Text>
					<EmptySpace />
					<Text  style={styles.text}>Рис. 1. Зона защиты одиночного стержневого молниеотвода</Text>
					<View>
						<Image style={{...styles.image, height:200}} src={osm}/>
					</View>
					<EmptySpace />
					<Text  style={styles.text}>Таблица 1. Соотношение надежности защиты и высоты конуса, молниеотвода и высота молниеотвода</Text>
					<View>
						<Image style={{...styles.image, height:200}} src={oneRoadTable}/>
					</View>
					<Text style={{...styles.formula, ...styles.formula_header}}>Высота молниеотвода</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>h = {light} м</Text>
					<FromReliabilityOneRoad
						zoneHeight = {zoneHeight}
						radiusGround = {radiusGround}
						reliability = {reliability}
						light = {light}
					/>
					<Text style={{...styles.formula, ...styles.formula_header}}>Радиус зоны на уровне высоты здания, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>rx = r0 * (h0 - hx) / h0</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>rx = {radiusGround} * ({zoneHeight} - {hx}) / {zoneHeight} = {radiusTop} м</Text>

				</View>)
			case TWO_ROD:
				return (<View>
					<Text  style={styles.description}>Расчет зоны молниезащиты двойного стержневого молниеотвода</Text>
					<EmptySpace />
					<Text  style={styles.text}>Рис. 1. Зона защиты двойного стержневого молниеотвода</Text>
					<View>
						<Image style={{...styles.image, height:200}} src={dsm}/>
					</View>
					<EmptySpace />
					<Text  style={styles.text}>Таблица 1. Соотношение надежности защиты и высоты конуса, молниеотвода и высота молниеотвода   </Text>
					<View>
						<Image style={{...styles.image, height:200}} src={oneRoadTable}/>
					</View>
					<Text style={{...styles.formula, ...styles.formula_header}}>Высота молниеотвода</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>h = {light} м</Text>
					<FromReliabilityOneRoad
						zoneHeight = {zoneHeight}
						radiusGround = {radiusGround}
						reliability = {reliability}
						light = {light}
					/>

					<Text style={{...styles.formula, ...styles.formula_header}}>Радиус зоны на уровне высоты здания, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>rx = r0 * (h0 - hx) / h0</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>rx = {radiusGround} * ({zoneHeight} - {hx}) / {zoneHeight} = {radiusTop} м</Text>

					<Text  style={styles.text}>Таблица 2. Соотношение надежности защиты и расстояние между стержнеыми молниеприемники</Text>
					<View>
						<Image style={{...styles.image, height:200}} src={twoRoadTable}/>
					</View>

					<FromReliabilityTwoRoad
						reliability = {reliability}
						light = {light}
						lmax = {lmax}
						Lc = {Lc}
					/>

					<Text style={{...styles.formula, ...styles.formula_header}}>Высота провеса, hc, м</Text>
					{
						l > Lc
							?
							<View>
								<Text style={{...styles.formula, ...styles.formula_content}}>hc = h0 * (Lmax - L)/(Lmax - lc)</Text>
								<Text style={{...styles.formula, ...styles.formula_content}}>hc = {zoneHeight} * ({lmax} - {l})/({lmax} - {Lc}) = {hc} м</Text>
							</View>
							:
							<View>
								<Text style={{...styles.formula, ...styles.formula_content}}>hc = h0</Text>
								<Text style={{...styles.formula, ...styles.formula_content}}>hc = {zoneHeight} = {hc} м</Text>
							</View>
					}

					<Text style={{...styles.formula, ...styles.formula_header}}>Полуширина горизонтального сечения rcx, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>rcx = r0 * (hc - hx) / hc, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>rcx = {radiusGround} * ({hc} - {hx}) / {hc} = {rcx} м</Text>


				</View>)
			case ONE_CABLE:
				return (<View>
					<Text  style={styles.description}>Расчёт зоны молниезащиты одиночного тросового молниеотвода</Text>
					<EmptySpace />
					<Text  style={styles.text}>Рис. 1. Зона защиты одиночного тросового молниеотвода</Text>
					<View>
						<Image style={{...styles.image, height:200}} src={otm}/>
					</View>
					<EmptySpace />
					<Text  style={styles.text}>Таблица 1. Соотношение надежности защиты и высоты конуса, молниеотвода и высота молниеотвода</Text>
					<View>
						<Image style={{...styles.image, height:200}} src={oneCableTable}/>
					</View>
					<Text style={{...styles.formula, ...styles.formula_header}}>Высота молниеотвода</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>h = {light} м</Text>
					<FromReliabilityOneCable
						zoneHeight = {zoneHeight}
						radiusGround = {radiusGround}
						reliability = {reliability}
						light = {light}
					/>
					<Text style={{...styles.formula, ...styles.formula_header}}>Радиус зоны на уровне высоты здания, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>rx = r0 * (h0 - hx) / h0</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>rx = {radiusGround} * ({zoneHeight} - {hx}) / {zoneHeight} = {radiusTop} м</Text>

				</View>)
			case TWO_CABLE:
				return (<View>
					<Text  style={styles.description}>Расчёт зоны молниезащиты двойного тросового молниеотвода</Text>
					<EmptySpace />
					<Text  style={styles.text}>Рис. 1. Зона защиты двойного тросового молниеотвода</Text>
					<View>
						<Image style={{...styles.image, height:200}} src={dtm}/>
					</View>
					<EmptySpace />
					<Text  style={styles.text}>Таблица 1. Соотношение надежности защиты и высоты конуса, молниеотвода и высота молниеотвода   </Text>
					<View>
						<Image style={{...styles.image, height:200}} src={oneCableTable}/>
					</View>
					<Text style={{...styles.formula, ...styles.formula_header}}>Высота молниеотвода</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>h = {light} м</Text>
					<FromReliabilityOneCable
						zoneHeight = {zoneHeight}
						radiusGround = {radiusGround}
						reliability = {reliability}
						light = {light}
					/>

					<Text style={{...styles.formula, ...styles.formula_header}}>Радиус зоны на уровне высоты здания, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>rx = r0 * (h0 - hx) / h0</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>rx = {radiusGround} * ({zoneHeight} - {hx}) / {zoneHeight} = {radiusTop} м</Text>

					<Text  style={styles.text}>Таблица 2. Соотношение надежности защиты и расстояние между стержнеыми молниеприемники</Text>
					<View>
						<Image style={{...styles.image, height:200}} src={twoCableTable}/>
					</View>

					<FromReliabilityTwoCable
						reliability = {reliability}
						light = {light}
						lmax = {lmax}
						Lc = {Lc}
					/>

					<Text style={{...styles.formula, ...styles.formula_header}}>Высота провеса hc, м</Text>

					{
						l > Lc
							?
							<View>
								<Text style={{...styles.formula, ...styles.formula_content}}>hc = h0 * (lmax - l) / (lmax - lc), м</Text>
								<Text style={{...styles.formula, ...styles.formula_content}}>hc = {zoneHeight} * ({lmax} - {distanceSec}) / ({lmax} - {Lc}) = {sagHeight} м</Text>
							</View>
							:
							<View>
								<Text style={{...styles.formula, ...styles.formula_content}}>hc = h0</Text>
								<Text style={{...styles.formula, ...styles.formula_content}}>hc = {zoneHeight} = {sagHeight} м</Text>
							</View>
					}
					<Text style={{...styles.formula, ...styles.formula_header}}>Полуширина горизонтального сечения rcx, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>rcx = r0 * (hc - hx) / hc, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>rcx = {radiusGround} * ({sagHeight} - {hx}) / {sagHeight} = {rcx} м</Text>


				</View>)
		}

		return (<View/>)
}

const FromReliabilityOneRoad = (props) => {
	const {zoneHeight, radiusGround, reliability, light} = props

	switch (reliability) {
		case RELIAB_MIN:
			if (light > 0 && light <= 100) {
				return (<View>
					<Text style={{...styles.formula, ...styles.formula_header}}>Высота зоны h0, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>h0 = 0.85 * h</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>h0 = 0.85 * {light} = {zoneHeight} м</Text>
					<Text style={{...styles.formula, ...styles.formula_header}}>Радиус зоны на уровне земли, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>r0 = 1,2 * h</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>r0 = 1,2 * {light} = {radiusGround} м</Text>
				</View>)
			}
			else if (light > 100){
				return (<View>
					<Text style={{...styles.formula, ...styles.formula_header}}>Высота зоны h0, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>h0 = 0.85 * h</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>h0 = 0.85 * {light} = {zoneHeight} м</Text>
					<Text style={{...styles.formula, ...styles.formula_header}}>Радиус зоны на уровне земли, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>r0 = (1,2 - ((h-100)/1000))h</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>r0 = (1.2 - (({light}-100)/1000)){light} = {radiusGround} м</Text>
				</View>)
			}
		case RELIAB_AVER:
			if (light > 0 && light <= 30) {
				return (<View>
					<Text style={{...styles.formula, ...styles.formula_header}}>Высота зоны h0, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>h0 = 0.8 * h</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>h0 = 0.8 * {light} = {zoneHeight} м</Text>
					<Text style={{...styles.formula, ...styles.formula_header}}>Радиус зоны на уровне земли, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>r0 = 0,8 * h</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>r0 = 0,8 * {light} = {radiusGround} м</Text>
				</View>)
			} else if (light > 30 && light <= 100) {
				return (<View>
					<Text style={{...styles.formula, ...styles.formula_header}}>Высота зоны h0, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>h0 = 0.8 * h</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>h0 = 0.8 * {light} = {zoneHeight} м</Text>
					<Text style={{...styles.formula, ...styles.formula_header}}>Радиус зоны на уровне земли, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>r0 = (0,8 - (1,43(h-30)/1000))h</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>r0 = (0.8 - (1,43({light}-30)/1000)){light} = {radiusGround} м</Text>
				</View>)
			} else if (light > 100 && light <= 150) {
				return (<View>
					<Text style={{...styles.formula, ...styles.formula_header}}>Высота зоны h0, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>h0 = (0,8 - ((h-100)/1000))h</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>h0 = (0,8 - (({light}-100)/1000)){light} = {zoneHeight} м</Text>
					<Text style={{...styles.formula, ...styles.formula_header}}>Радиус зоны на уровне земли, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>r0 = 0,7 * h</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>r0 = 0,7 * {light} = {radiusGround} м</Text>
				</View>)
			}
		case RELIAB_MAX:
			if (light > 0 && light <= 30) {
				return (<View>
					<Text style={{...styles.formula, ...styles.formula_header}}>Высота зоны h0, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>h0 = 0.7 * h</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>h0 = 0.7 * {light} = {zoneHeight} м</Text>
					<Text style={{...styles.formula, ...styles.formula_header}}>Радиус зоны на уровне земли, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>r0 = 0,6 * h</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>r0 = 0,6 * {light} = {radiusGround} м</Text>
				</View>)
			} else if (light > 30 && light <= 100) {
				return (<View>
					<Text style={{...styles.formula, ...styles.formula_header}}>Высота зоны h0, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>h0 = (0,7 - (7,14(h-30)/10000))h</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>h0 = (0,7 - (7,14({light}-30)/10000)){light} = {zoneHeight} м</Text>
					<Text style={{...styles.formula, ...styles.formula_header}}>Радиус зоны на уровне земли, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>r0 = (0,6 - (1,43(h-30)/1000))h</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>r0 = (0.6 - (1,43({light}-30)/1000)){light} = {radiusGround} м</Text>
				</View>)
			} else if (light > 100 && light <= 150) {
				return (<View>
					<Text style={{...styles.formula, ...styles.formula_header}}>Высота зоны h0, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>h0 = (0,65 - ((h-100)/1000))h</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>h0 = (0,65 - (({light}-100)/1000)){light} = {zoneHeight} м</Text>
					<Text style={{...styles.formula, ...styles.formula_header}}>Радиус зоны на уровне земли, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>r0 = (0,5 - (2(h-100)/1000))h</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>r0 = (0.5 - (2({light}-100)/1000)){light} = {radiusGround} м</Text>
				</View>)
			}
			break;
	}

}

const
	FromReliabilityTwoRoad = (props) => {
	const {reliability, light, lmax, Lc} = props

	switch (reliability) {
		case RELIAB_MIN:
			if (light > 0 && light <= 30) {
				return (<View>
					<Text style={{...styles.formula, ...styles.formula_header}}>Предельное расстояние между стержневыми
						молниеприемниками Lmax, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>Lmax = 5,75 * h</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>Lmax = 5,75 * {light} = {lmax} м</Text>
				</View>)
			} else if (light > 30 && light <= 100) {
				return (<View>
					<Text style={{...styles.formula, ...styles.formula_header}}>Предельное расстояние между стержневыми
						молниеприемниками Lmax, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>Lmax = (5,75 - (3,75(h-30)/1000))h</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>Lmax = (5,75 -
						(3,75({light}-30)/1000)){light} = {lmax} м</Text>
				</View>)
			} else if (light > 100) {
				return (<View>
					<Text style={{...styles.formula, ...styles.formula_header}}>Предельное расстояние между стержневыми
						молниеприемниками Lmax, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>Lmax = 5,5 * h</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>Lmax = 5,5 * {light} = {lmax} м</Text>
				</View>)
			}
		case RELIAB_AVER:
			if (light > 0 && light <= 30) {
				return (<View>
					<Text style={{...styles.formula, ...styles.formula_header}}>Предельное расстояние между стержневыми
						молниеприемниками Lmax, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>Lmax = 4,75 * h</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>Lmax = 4,75 * {light} = {lmax} м</Text>
				</View>)
			} else if (light > 30 && light <= 100) {
				return (<View>
					<Text style={{...styles.formula, ...styles.formula_header}}>Предельное расстояние между стержневыми
						молниеприемниками Lmax, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>Lmax = (4,75 - (3,57(h-30)/1000))h</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>Lmax = (4,75 -
						(3,57({light}-30)/1000)){light} = {lmax} м</Text>
				</View>)
			} else if (light > 100) {
				return (<View>
					<Text style={{...styles.formula, ...styles.formula_header}}>Предельное расстояние между стержневыми
						молниеприемниками Lmax, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>Lmax = 4,5 * h</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>Lmax = 4,5 * {light} = {lmax} м</Text>
				</View>)
			}
		case RELIAB_MAX:
			if (light > 0 && light <= 30) {
				return (<View>
					<Text style={{...styles.formula, ...styles.formula_header}}>Предельное расстояние между стержневыми
						молниеприемниками Lmax, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>Lmax = 4,25 * h</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>Lmax = 4,25 * {light} = {lmax} м</Text>
				</View>)
			} else if (light > 30 && light <= 100) {
				return (<View>
					<Text style={{...styles.formula, ...styles.formula_header}}>Предельное расстояние между стержневыми
						молниеприемниками Lmax, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>Lmax = (4,75 - (3,57(h-30)/1000))h</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>Lmax = (4,75 -
						(3,57({light}-30)/1000)){light} = {lmax} м</Text>
				</View>)
			} else if (light > 100) {
				return (<View>
					<Text style={{...styles.formula, ...styles.formula_header}}>Предельное расстояние между стержневыми
						молниеприемниками Lmax, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>Lmax = 4 * h</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>Lmax = 4 * {light} = {lmax} м</Text>
				</View>)
			}
	}
}

const FromReliabilityOneCable = (props) => {
	const {zoneHeight, radiusGround, reliability, light} = props

	switch (reliability) {
		case RELIAB_MIN:
				return (<View>
					<Text style={{...styles.formula, ...styles.formula_header}}>Высота зоны h0, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>h0 = 0.87 * h</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>h0 = 0.87 * {light} = {zoneHeight} м</Text>
					<Text style={{...styles.formula, ...styles.formula_header}}>Радиус зоны на уровне земли, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>r0 = 1,5 * h</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>r0 = 1,5 * {light} = {radiusGround} м</Text>
				</View>)
		case RELIAB_AVER:
			if (light > 0 && light <= 30) {
				return (<View>
					<Text style={{...styles.formula, ...styles.formula_header}}>Высота зоны h0, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>h0 = 0.8 * h</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>h0 = 0.8 * {light} = {zoneHeight} м</Text>
					<Text style={{...styles.formula, ...styles.formula_header}}>Радиус зоны на уровне земли, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>r0 = 0,95 * h</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>r0 = 0,95 * {light} = {radiusGround} м</Text>
				</View>)
			} else if (light > 30 && light <= 100) {
				return (<View>
					<Text style={{...styles.formula, ...styles.formula_header}}>Высота зоны h0, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>h0 = 0.8 * h</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>h0 = 0.8 * {light} = {zoneHeight} м</Text>
					<Text style={{...styles.formula, ...styles.formula_header}}>Радиус зоны на уровне земли, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>r0 = (0,95 - (7,14(h-30)/10000))h</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>r0 = (0.95 - (7,14({light}-30)/10000)){light} = {radiusGround} м</Text>
				</View>)
			} else if (light > 100 && light <= 150) {
				return (<View>
					<Text style={{...styles.formula, ...styles.formula_header}}>Высота зоны h0, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>h0 = (0,8 - ((h-100)/1000))h</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>h0 = (0,8 - (({light}-100)/1000)){light} = {zoneHeight} м</Text>
					<Text style={{...styles.formula, ...styles.formula_header}}>Радиус зоны на уровне земли, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>r0 = 0,9 - ((h-100)/1000))h</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>r0 = 0,9 - (({light}-100)/1000)){light} = {radiusGround} м</Text>
				</View>)
			}
			break;
		case RELIAB_MAX:
			if (light > 0 && light <= 30) {
				return (<View>
					<Text style={{...styles.formula, ...styles.formula_header}}>Высота зоны h0, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>h0 = 0.75 * h</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>h0 = 0.75 * {light} = {zoneHeight} м</Text>
					<Text style={{...styles.formula, ...styles.formula_header}}>Радиус зоны на уровне земли, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>r0 = 0,7 * h</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>r0 = 0,7 * {light} = {radiusGround} м</Text>
				</View>)
			} else if (light > 30 && light <= 100) {
				return (<View>
					<Text style={{...styles.formula, ...styles.formula_header}}>Высота зоны h0, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>h0 = (0,75 - (4,28(h-30)/10000))h</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>h0 = (0,75 - (4,28({light}-30)/10000)){light} = {zoneHeight} м</Text>
					<Text style={{...styles.formula, ...styles.formula_header}}>Радиус зоны на уровне земли, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>r0 = (0,7 - (1,43(h-30)/1000))h</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>r0 = (0.7 - (1,43({light}-30)/1000)){light} = {radiusGround} м</Text>
				</View>)
			} else if (light > 100 && light <= 150) {
				return (<View>
					<Text style={{...styles.formula, ...styles.formula_header}}>Высота зоны h0, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>h0 = (0,72 - ((h-100)/1000))h</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>h0 = (0,72 - (({light}-100)/1000)){light} = {zoneHeight} м</Text>
					<Text style={{...styles.formula, ...styles.formula_header}}>Радиус зоны на уровне земли, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>r0 = (0,6 - ((h-100)/1000))h</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>r0 = (0.6 - (({light}-100)/1000)){light} = {radiusGround} м</Text>
				</View>)
			}
	}

}

const FromReliabilityTwoCable = (props) => {

	const {reliability, light, lmax} = props

	switch (reliability) {
		case RELIAB_MIN:
				return (<View>
					<Text style={{...styles.formula, ...styles.formula_header}}>Предельное расстояние между стержневыми
						молниеприемниками Lmax, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>Lmax = 6 * h</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>Lmax = 6 * {light} = {lmax} м</Text>
				</View>)
		case RELIAB_AVER:
			if (light > 0 && light <= 30) {
				return (<View>
					<Text style={{...styles.formula, ...styles.formula_header}}>Предельное расстояние между стержневыми
						молниеприемниками Lmax, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>Lmax = 5 * h</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>Lmax = 5 * {light} = {lmax} м</Text>
				</View>)
			} else if (light > 30 && light <= 100) {
				return (<View>
					<Text style={{...styles.formula, ...styles.formula_header}}>Предельное расстояние между стержневыми
						молниеприемниками Lmax, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>Lmax = 5 * h</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>Lmax = 5 * {light} = {lmax} м</Text>
				</View>)
			} else if (light > 100) {
				return (<View>
					<Text style={{...styles.formula, ...styles.formula_header}}>Предельное расстояние между стержневыми
						молниеприемниками Lmax, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>Lmax = (5 - (5 * (h-100)/100))h</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>Lmax = (5 - (5 * ({light}-100)/100)) * {light} = {lmax} м</Text>
				</View>)
			}
		case RELIAB_MAX:
			if (light > 0 && light <= 30) {
				return (<View>
					<Text style={{...styles.formula, ...styles.formula_header}}>Предельное расстояние между стержневыми
						молниеприемниками Lmax, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>Lmax = 4,75 * h</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>Lmax = 4,75 * {light} = {lmax} м</Text>
				</View>)
			} else if (light > 30 && light <= 100) {
				return (<View>
					<Text style={{...styles.formula, ...styles.formula_header}}>Предельное расстояние между стержневыми
						молниеприемниками Lmax, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>Lmax = (4,75 - (3,57(h-30)/1000))h</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>Lmax = (4,75 -
						(3,57({light}-30)/1000)){light} = {lmax} м</Text>
				</View>)
			} else if (light > 100) {
				return (<View>
					<Text style={{...styles.formula, ...styles.formula_header}}>Предельное расстояние между стержневыми
						молниеприемниками Lmax, м</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>Lmax = (4,5 - (5 * (h-100)/1000)) * h</Text>
					<Text style={{...styles.formula, ...styles.formula_content}}>Lmax = (4,5 - (5 * ({light}-100)/1000)) * {light} = {lmax} м</Text>
				</View>)
			}
	}
}

export default (props) => {

	const { date, name, address, desc, author, imgData='', td, ng, n, type, buildLength, buildWidth, buildHeight} = props

	return (
		<Document>
			<Page style={styles.body} wrap>

				{/*Header*/}
				<View fixed style={{marginBottom: 30}}>
					<View style={{width:'14%'}}>
						<Image style={styles.logo} src={logo}/>
					</View>
					<View style={styles.colon}>
						<Text
							render={({pageNumber}) => pageNumber === 1 ? date : name}
							fixed
						/>
					</View>
					<Text style={styles.tor}
								fixed
					>ИМПУЛЬС 1.0.0</Text>
				</ View>

				<Text
					style={styles.pageNumber}
					render={({pageNumber, totalPages}) => `${pageNumber} / ${totalPages}`}
					fixed
				/>

				{/*Page 1*/}
				<EmptySpace />
				<EmptySpace />
				<EmptySpace />
				<EmptySpace />
				<Text style={{...styles.description, textAlign: 'center'}}>{name}</Text>
				<EmptySpace />
				<Text style={{...styles.text, textAlign: 'center'}}>{address}</Text>
				<EmptySpace />
				<EmptySpace />
				<Text style={{...styles.description, textAlign: 'center'}}>ОТЧЕТ</Text>
				<Text style={{...styles.text, textAlign: 'center'}}>Молниезащита и заземление</Text>
				<Text style={{...styles.text, textAlign: 'center'}}>Расчет молниезащиты: определение зон молниезащиты молниеприемников</Text>
				<Text break/>

				{/*Page 2*/}
				<Text style={{...styles.subtitle, marginBottom:12}}>Описание объекта</Text>
				<Text style={{...styles.text, ...styles.m12}}>Дата: {date}</Text>
				<Text style={{...styles.text, ...styles.m12}}>Объект: {name}</Text>
				<Text style={{...styles.text, ...styles.m12}}>Адрес: {address}</Text>
				<Text style={{...styles.text, ...styles.m12}}>{desc}</Text>
				<Text style={{...styles.text, ...styles.m12}}>Автор: {author}</Text>
				<EmptySpace />
				{imgData ? <Image style={styles.image} src={imgData}/> : null  }
				<EmptySpace />

				<Text break/>

				{/*Page 2*/}
				<Text style={{...styles.title, ...styles.fw_normal}}>ИСХОДНЫЕ ДАННЫЕ И РЕЗУЛЬТАТЫ</Text>
				<EmptySpace />

				<FData
					props = {props}
				/>

				<Text break/>

				{/*Page 3*/}
				<Text style={{...styles.title, ...styles.fw_normal}}>ФОРМУЛЫ</Text>
				<EmptySpace />

				<Text  style={styles.description}>Расчет ожидаемого количества поражений молнией в год</Text>
				<EmptySpace />
				<Text  style={styles.text}>Укрупненные данные по грозовой активности на территории России</Text>
				<View>
					<Image style={{...styles.image, height:300}} src={table}/>
				</View>
				<EmptySpace />
				<Text style={{...styles.formula, ...styles.formula_header}}>Плотность ударов в землю, Ng</Text>
				<Text style={{...styles.formula, ...styles.formula_content}}>Ng = 6,7 * Td / 100</Text>
				<Text style={{...styles.formula, ...styles.formula_content}}>Ng = 6,7 * {td} / 100 = {ng} м</Text>

				<Text style={{...styles.formula, ...styles.formula_header}}>Ожидаемое количество ударов молнией в год, N</Text>
				{
					type === 'Прямоуголный'
						?
						<View>
							<Text style={{...styles.formula, ...styles.formula_content}}>N = ((S + 6 * h) * (L + 6 * h) - 7,7 * h * h) * Ng / 1000000</Text>
							<Text style={{...styles.formula, ...styles.formula_content}}>N = (({buildWidth} + 6 * {buildHeight}) * ({buildLength} + 6 * {buildHeight}) - 7,7 * {buildHeight} * {buildHeight}) * {ng} / 1000000 = {n}</Text>
						</View>
						:
						<View>
							<Text style={{...styles.formula, ...styles.formula_content}}>N = 9 * pi * h * h * Ng / 1000000</Text>
							<Text style={{...styles.formula, ...styles.formula_content}}>N = 9 * 3,14 * {buildHeight} * {buildHeight} * {ng} / 1000000 = {n}</Text>
						</View>
				}
				<Text break/>

				<FContent
					props = {props}
				/>

				<Text break/>

				{/*Page 3*/}
				<Text style={{...styles.title, ...styles.fw_normal}}>Список  используемой  литературы:</Text>
				<List>
					<ListItem>1.	Тульчин И.К.,  Нудлер Г.И.  Электрические  сети  и  электрооборудование  жилых  и  общественных  зданий. – 2-е изд., перераб. и доп. – М.:Энергоатомиздат, 1990. – 480 с.: ил.</ListItem>
				</List>


			</Page>
		</Document>)
}





// WEBPACK FOOTER //
// ./src/react/ui/PDFCreation/PDFLightCountReport.js